module.exports = __webpack_public_path__ + "img/PlentyOfPizza_Logo_small.54de4f66.png";